import en from './locales/en.json';
import vn from './locales/vn.json';

const messages = {
  vn: vn,
  en: en,
}

export default messages
